import { Pipe, PipeTransform } from '@angular/core';
import { STATUS_LABELS } from '../constants/status.constants';

/**
 * Pipe to transform status values into human-readable labels
 *
 * Usage:
 * {{ 'active' | statusLabel }} => 'Attivo'
 * {{ user.status | statusLabel }} => 'Attivo'
 */
@Pipe({
  name: 'statusLabel',
  standalone: true
})
export class StatusLabelPipe implements PipeTransform {
  transform(value: string): string {
    return STATUS_LABELS[value] || value;
  }
}
